import { FC, PropsWithChildren } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import {
  NextBestActionDefinitionAction,
  NextBestActionType,
} from "../../../../projection/nextBestActionDefinition/nextBestActionDefinition";

enum NextBestActionCardStatus {
  IDLE = "IDLE",
  SUCCESS = "SUCCESS",
}

interface NextBestActionCardOnActionTriggeredFunctionArgs {
  readonly action: NextBestActionDefinitionAction;
}

interface NextBestActionCardOnActionTriggeredFunction {
  (args: NextBestActionCardOnActionTriggeredFunctionArgs): void;
}

interface NextBestActionItemProps<T extends NextBestActionType> extends PropsWithChildren {
  readonly action: NextBestActionDefinitionAction<T>;
  readonly basePath: string;
  readonly segment: Segment;
  readonly country: Country;
}

type NextBestActionItem<T extends NextBestActionType> = FC<NextBestActionItemProps<T>>;

export type { NextBestActionItem, NextBestActionCardOnActionTriggeredFunction };
export { NextBestActionCardStatus };
